import React from 'react'
import Seo from './Seo'
import { useEffect, useState} from 'react'
import { baseURL } from './domainValidator';
import swal from 'sweetalert';

export default function DownloadFile() {

    const [fileDownLoadFlag, setFileDownLoadFlag] = useState(null)

    useEffect(()=>{
        const id= window.location.search.split('=', 4)[1].split('&', 1)[0]
        
        const downLoadName = window.location.search.split('=', 4)[2].replaceAll('%20', ' ')

        // console.log(id, downLoadName, 'window.location.search');
        
        const headers = {headers: {'auth-token': localStorage.getItem('authToken'), 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Frame-Options': 'DENY'}};
        fetch(`${baseURL}/download?key=${id}`, { headers })
        .then((res) => {
            if (!res.ok) throw new Error('Invalid or expired link.');
            return res.blob(); 
        })
        .then((blob) => {

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', downLoadName); 
            document.body.appendChild(link);
            link.click();
            link.remove(); 

            swal({
                title: 'Success!',
                text: 'File Downloaded Successfully',
                type: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                window.location.href = 'https://www.agilustech.in/'
              });
           
        })
        .catch((error) => {
            console.error('Error downloading PDF:', error.message);
            // swal('Error', error.message || 'Failed to download the PDF.', 'error');
            swal({
                title: 'Error!',
                text: error.message || 'Failed to download the PDF.',
                type: 'error',
                confirmButtonText: 'OK'
              }).then(() => {
                window.location.href = 'https://www.agilustech.in/'
              });

        });
    })

  return (
    <div className='container position-relative' style={{height: '100vh'}}>
      <Seo
        title="Download Resources"
        description="Download Agilus brochures, datasheets and resources."
        path="/downloadfile"
      />
        <p 
        style={{
            position: 'absolute',
            left: '50%',
            top: '40%',
            transform : 'translate(-50%, 50%)',
            fontSize: '40px'
        }}
        >Loading ...</p>
    </div>
  )
}
